export function truncate(value = "", desiredLength) {
  if (value && value.length >= desiredLength) {
    return `${value.substring(0, desiredLength)}...`;
  } else {
    return value;
  }
}

export function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * Clones a string with a suffix and incrementing the number if it already exists
 * @param {string} text String to clone
 * @param {string} [suffix] Suffix to append. Defaults to "Copy".
 * @returns New string with suffix (ie. "Campaign" -> "Campaign Copy" -> "Campaign Copy 2")
 */
export function cloneString(text, suffix = "Copy") {
  if (!text) {
    return suffix;
  }

  if (text.includes(suffix)) {
    const parts = text.split(" ");
    const last = parts[parts.length - 1];
    const last2 = parts[parts.length - 2];

    if (last === suffix) {
      return text + " 2";
    }
    if (last2 === suffix) {
      const re = /^\d+$/;
      if (re.test(last)) {
        const num = +last + 1;
        return text.replace(last, num);
      }
    }
  }
  return (text + " " + suffix).trim();
}

const acronyms = {
  api: "API",
  id: "ID",
  ids: "IDs",
  og: "OG",
  url: "URL",
  urls: "URLs",
  pin: "PIN",
};

export function humanizeString(str) {
  return str
    .toString()
    .trim()
    .split(/[_-\s]+/) // replace underscores and dashes with spaces
    .map(
      (word) =>
        (word && acronyms[word.toLowerCase()]) ??
        word[0].toUpperCase() + word.slice(1).toLowerCase(),
    ) // acronym or capitalize first letter
    .join(" ");
}

export function slugify(str) {
  return str
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[\s_-]+/g, "-") // replace spaces, underscores, and multiple dashes with a single dash
    .replace(/[^a-z0-9-]/g, "") // remove all non-alphanumeric characters except dashes
    .replace(/^-+|-+$/g, ""); // remove leading and trailing dashes
}

/**
 * Convert a value to an array of strings.
 * @param {any} value The value to convert
 * @returns {string[]} The converted array
 */
export function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  } else if (value instanceof Date) {
    return [value.toISOString()];
  } else if (typeof value === "object") {
    return Object.values(value).map((v) => v.toString());
  } else {
    return value.toString().split(",");
  }
}

/**
 * Convert a value to a boolean. Returns false if unknown.
 * @param {*} value
 * @returns {boolean}
 */
export function toBoolean(value) {
  switch (typeof value) {
    case "boolean":
      return value;
    case "number":
      return value !== 0;
    case "string":
      return ["true", "1", "yes", "on"].includes(value.toLowerCase());
    default:
      return false;
  }
}
